class CartUpsellPopup extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (evt) => {
      if (evt.target.closest("[data-cart-upsell-popup-close]")) this.close();
    });
  }

  open() {
    this.setAttribute("open", "");
    document.body.classList.add("overflow-hidden-cart-upsell-popup");
  }

  close() {
    this.removeAttribute("open");
    document.body.classList.remove("overflow-hidden-cart-upsell-popup");
  }
}

customElements.define("cart-upsell-popup", CartUpsellPopup);
